export const siteSettings = {
  // Informations de base
  siteName: "Emmaüs",
  tagline: "Une église, une famille, une mission",
  
  // Logo
  logo: "https://res.cloudinary.com/dt6ammifo/image/upload/v1780270326/Gemini_Generated_Image_lp5ti0lp5ti0lp5t_a0guoi.png",
  logoAlt: "Logo Emmaüs",
  
  // Couleurs
  colors: {
    primary: "#D4A853",
    primaryLight: "#E8C989",
    primaryDark: "#B8923A",
    secondary: "#2D5F3F",
    secondaryLight: "#4A7F5F",
    accent: "#F5F0E8",
    text: "#2C3E50",
    textLight: "#5D6D7E",
    background: "#FFFFFF",
    backgroundWarm: "#FAF8F5",
    footer: "#1A1A2E",
    footerText: "#FFFFFF",
  },
  
  // Contact
  phone: "+33 1 23 45 67 89",
  email: "contact@emmaus.fr",
  whatsapp: "+33 6 12 34 56 78",
  address: "123 Rue de la Foi, 75001 Paris, France",
  
  // Réseaux sociaux
  social: {
    facebook: "https://facebook.com/emmaus",
    instagram: "https://instagram.com/emmaus",
    youtube: "https://youtube.com/emmaus",
    twitter: "https://twitter.com/emmaus",
  },
  
  // Horaires du culte principal
  serviceTimes: {
    sunday: "10:00 - 12:00",
    wednesday: "19:00 - 20:30",
  },
  
  // Footer
  footer: {
    copyright: "2024 Emmaüs Église Chrétienne. Tous droits réservés.",
    slogan: "Proclamer Christ, Édifier des disciples",
  },
  
  // Messages pastoraux
  pastor: {
    name: "Pasteur Jean Dupont",
    title: "Pasteur Principal",
    message: "Bienvenue à Emmaüs ! Notre désir est de vous accueillir dans une famille de foi où chacun peut découvrir l'amour de Dieu, grandir spirituellement et trouver sa place dans le corps de Christ.",
  },
  
  // Vision & Mission
  vision: "Devenir une église modèle de discipleship qui impacte notre communauté et le monde pour Christ.",
  mission: "Proclamer l'Évangile, édifier les croyants, servir la communauté et envoyer des missionnaires.",
};